import React from "react";
import ExistingPhotoPicker from "./ExistingPhotoPicker";
import PhotoUploader from "./PhotoUploader";

export default function HeroEditor({ clientId, hero, name, slug, onChange, onNameChange, onSlugChange }) {
  return (
    <fieldset style={{ marginBottom: 24 }}>
      <legend><strong>Hero</strong></legend>
      <label>Nom complet
        <input value={name || ""}
               onChange={(e) => onNameChange(e.target.value)}
               style={{ width: "100%", padding: 8, margin: "4px 0 12px" }} />
      </label>
      <label>Slug (URL : &lt;slug&gt;.minibio.pro)
        <input value={slug || ""}
               onChange={(e) => onSlugChange(e.target.value)}
               style={{ width: "100%", padding: 8, margin: "4px 0 12px" }} />
      </label>
      <label>Sous-titre
        <input value={hero?.subtitle || ""}
               onChange={(e) => onChange({ ...hero, subtitle: e.target.value })}
               style={{ width: "100%", padding: 8, margin: "4px 0 12px" }} />
      </label>
      <div>Photo hero</div>
      <PhotoUploader
        clientId={clientId}
        slot="hero"
        currentFilename={hero?.photo_filename}
        onChange={(filename) => onChange({ ...hero, photo_filename: filename })}
      />
      <ExistingPhotoPicker
        clientId={clientId}
        onChange={(filename) => onChange({ ...hero, photo_filename: filename })}
      />
      <label>Cadrage de la photo sur ordinateur
        <select value={hero?.photo_position || "haut"}
                onChange={(e) => onChange({ ...hero, photo_position: e.target.value })}
                style={{ width: "100%", padding: 8, margin: "4px 0 4px" }}>
          <option value="tout_en_haut">Tout en haut</option>
          <option value="haut">Haut (par défaut)</option>
          <option value="centre">Centre</option>
          <option value="bas">Bas</option>
        </select>
      </label>
      <small style={{ display: "block", color: "#666", marginBottom: 12 }}>
        Sur un écran d'ordinateur, seule une bande horizontale de la photo est visible.
        Choisissez la partie à montrer, puis vérifiez avec « Aperçu », vue « Ordinateur ».
      </small>
      <label>Image d'aperçu du lien (WhatsApp…)
        <select value={hero?.og_image_style || "photo"}
                onChange={(e) => onChange({ ...hero, og_image_style: e.target.value })}
                style={{ width: "100%", padding: 8, margin: "4px 0 4px" }}>
          <option value="photo">Photo</option>
          <option value="photo_bd">Photo + BD</option>
        </select>
      </label>
      <small style={{ display: "block", color: "#666", marginBottom: 12 }}>
        Image affichée quand on partage le lien du site. Photo + BD : la photo et les planches des chapitres 1 et 3.
        Prise en compte à la prochaine publication.
      </small>
    </fieldset>
  );
}
